export const setUnitData = (payload) => {
    return {
      type: "SET_UNIT_DATA",
      payload,
    };
  };